export default "__VITE_ASSET__e9795532__"